import html2canvas from "html2canvas";
import jsPDF from "jspdf";

export const arrayToObj = (array, name) => {
	const initialValue = {};
	return array.reduce((obj, item, key) => {
		return {
			...obj,
			[key]: {id: key, [name]: item}
		};
	}, initialValue);
};

export const chunkArray = (array, size) => {
	let result = [];
	for (let i = 0; i < array.length; i += size) {
		result.push(array.slice(i, i + size));
	}
	return result;
};

export const nextId = (items) => {
	const maxId = items.reduce((maxId, item) => Math.max(item, maxId), -1)
	return maxId + 1
};

export const highlightAll = (e) => e.target.select();

export const calc = (value) => {
	const keys = ["sun", "mon", "tue", "wed", "thu", "fri", "sat"];
	return keys.reduce((a, v) => {
		return a + (typeof value === "function" ? value(v) : value[v])
	}, 0);
};

const print = (pdf, print, fill, size, blob) => {
	const name = new Date().toLocaleTimeString([], {year: "numeric", month: "numeric", day: "numeric", hour: "2-digit", minute: "2-digit"});
	const opts = {
		allowTaint: true,
		removeContainer: true,
		backgroundColor: null,
		imageTimeout: 15000,
		logging: true,
		scale: 1.5,
		useCORS: true
	};
	return new Promise((resolve) => {
		html2canvas(print, opts).then((canvas) => {
			const img = canvas.toDataURL("image/jpeg");
			pdf.addImage(img, "JPEG", 10, 10, size[0]-20, size[1]-20);
			if(!blob) {
				window.open(pdf.output("bloburl", {filename: `${name}.pdf`}));
			}
			fill.innerHTML = "";
			resolve(pdf.output("blob"));
		})
		.catch((error) => {
			alert(error);
		});
	});
};

export const generatePDF = (blob = false) => {
	const target = document.querySelector("#calc");
	const f = document.querySelector("#printFill");
	const p = document.querySelector("#print");
	const clone = target.cloneNode(true);
	f.appendChild(clone);
	const size = [p.offsetWidth, p.offsetHeight];
	document.body.style.zoom = "100%";
	const pdf = new jsPDF(size[1] <= 1479 ? "l" : "p", "pt", size);
	return print(pdf, p, f, size, blob);
};

export const twoDecimal = (num) => {
	return Math.round((num + Number.EPSILON) * 100) / 100;
};

export const removeZero = (num) => {
	if (!Number(num)) return "0.00"
	return num < 1 ? String(num).slice(1, num.length) : num;
};